import { Controller } from "@hotwired/stimulus"

// แถบตำแหน่งดาวเรียลไทม์บน TODAY'S SKY hero
// ดึง /today_positions ทุก 60 วิ แล้วอัปเดตเลของศา/ลิปดา "ในการ์ดเดิม" (ห้าม re-render ทั้งใบ —
// entrance animation จะกะพริบ) + แฟลชสีเลขลิปดาให้เห็นว่าขยับ + อัปเดตเวลา "อัปเดตล่าสุด"
// ราศีเปลี่ยนช้าระดับวัน → วงล้อไม่ต้องอัปเดตกลางหน้า (โหลดหน้าใหม่ก็พอ)
export default class extends Controller {
  static targets = ["pos", "updatedAt"]
  static values = { url: String }

  connect() {
    this.timer = setInterval(() => this.refresh(), 60_000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async refresh() {
    let payload
    try {
      const res = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (!res.ok) return
      payload = await res.json()
    } catch {
      return // เน็ตสะดุด/แท็บพัก — รอรอบถัดไป ไม่ต้องรบกวนผู้ใช้
    }

    const positions = payload.positions || []
    this.posTargets.forEach((el, i) => {
      const p = positions[i]
      if (!p) return
      const min = String(p.min).padStart(2, "0")
      el.innerHTML = `${p.rasi_name} ${p.deg}°<span class="liptic tick">${min}'</span>`
      setTimeout(() => el.querySelector(".liptic")?.classList.remove("tick"), 300)
    })

    if (this.hasUpdatedAtTarget && payload.updated_at) {
      this.updatedAtTarget.textContent = payload.updated_at
    }
  }
}
